.
<template>
  <div class="Token"></div>
</template>

<script>
export default {
  created() {
    // console.log('location', location);
    let index = location.hash.indexOf('token/');
    // console.log('index', index);
    let token_id = location.hash.slice(index + 6);
    // console.log('token_id', token_id);
    // this.$store.commit('setTokenId', token_id);
    // this.$router.push('/token-info')
    this.$router.replace({
      name: 'TokenInfo',
      params: { tokenId: token_id },
    });
  },
};
</script>

<style></style>
